import { connect } from 'react-redux';
import Helmet from './helmet.component';

const mapStateToProps = ({ app }) => ({
  appName: app?.config?.appName,
});

export default connect(mapStateToProps)(Helmet);
